module.exports = "<div class=\"container basic-page\">\n    <div class=\"row--narrow\">\n        {{ ctrl.message }}\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/partials/comparator-error.html
// module id = 299
// module chunks = 0